<template>
  <router-view />
</template>
<script>
  export default {
    name: 'PlanoPagamentoModule',
  }
</script>
